var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationdark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94589 6.95772C2.94592 3.63113 5.65814 0.9375 9 0.9375C12.3419 0.9375 15.0541 3.63116 15.0541 6.95777C15.0542 7.73159 15.1062 8.31553 15.463 8.84045C15.5126 8.91237 15.5784 9.00244 15.6503 9.10086L15.6503 9.10088C15.7752 9.27185 15.9185 9.468 16.0273 9.63788C16.2191 9.93772 16.4066 10.2993 16.471 10.7206C16.6812 12.0952 15.7121 12.9852 14.7469 13.384C11.3474 14.7887 6.65262 14.7887 3.25309 13.384C2.28792 12.9852 1.31877 12.0952 1.52901 10.7206C1.59345 10.2993 1.78089 9.93772 1.97275 9.63788C2.08146 9.46799 2.22477 9.27183 2.34968 9.10086C2.4216 9.00242 2.48742 8.91232 2.53703 8.84039C2.89378 8.3155 2.94582 7.73149 2.94589 6.95772Z",
    fill: "#141B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.80756 13.3378C6.20787 13.2315 6.61864 13.4697 6.72503 13.8701C6.97995 14.8293 7.89054 15.5627 9.00018 15.5627C10.1098 15.5627 11.0204 14.8293 11.2753 13.8701C11.3817 13.4697 11.7925 13.2315 12.1928 13.3378C12.5931 13.4442 12.8314 13.855 12.725 14.2553C12.2922 15.8839 10.7772 17.0627 9.00018 17.0627C7.22313 17.0627 5.70816 15.8839 5.27534 14.2553C5.16896 13.855 5.40724 13.4442 5.80756 13.3378Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationdark);
export default __webpack_public_path__ + "static/media/notificationdark.dac88831cd0265c1283cf4d3bce49b72.svg";
export { ForwardRef as ReactComponent };